"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HIDE_DELAY = exports.SUCCESS_DELAY = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AlertModule = _interopRequireDefault(require("./Alert.module.scss"));

var _Preloader = _interopRequireDefault(require("../Preloader/Preloader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SUCCESS_DELAY = 2000; //ms

exports.SUCCESS_DELAY = SUCCESS_DELAY;
var HIDE_DELAY = 400; //ms

exports.HIDE_DELAY = HIDE_DELAY;

var Alert =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert() {
    _classCallCheck(this, Alert);

    return _possibleConstructorReturn(this, _getPrototypeOf(Alert).apply(this, arguments));
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hide = _this$props.hide,
          onClose = _this$props.onClose,
          status = _this$props.status,
          message = _this$props.message;
      var classes = (0, _classnames.default)(_AlertModule.default.alert, status && _AlertModule.default[status], hide && _AlertModule.default.hide);
      return _react.default.createElement("div", {
        className: classes
      }, status === "process" && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: _AlertModule.default.content
      }, _react.default.createElement("div", {
        className: _AlertModule.default.icon
      }, _react.default.createElement(_Preloader.default, {
        size: "20px",
        color: "#000"
      })), _react.default.createElement("p", {
        className: _AlertModule.default.text
      }, message)), _react.default.createElement("i", {
        className: "icon-close",
        onClick: onClose
      })), status === "success" && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: _AlertModule.default.content
      }, _react.default.createElement("div", {
        className: _AlertModule.default.icon
      }, _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, _react.default.createElement("path", {
        id: "Rounded_Rectangle_1044_copy_11",
        "data-name": "Rounded Rectangle 1044 copy 11",
        className: "cls-1",
        d: "M10,20C4.477,20,0,16.024,0,10.323A10.165,10.165,0,0,1,10,0,10,10,0,1,1,10,20ZM9.985,1a9.157,9.157,0,0,0-9,9.31c0,5.131,4.017,8.69,9,8.69A9,9,0,1,0,9.985,1Zm3.861,5.8L9.38,13.864a0.384,0.384,0,0,1-.4.1,0.405,0.405,0,0,1-.415-0.1L6.091,11.881a0.637,0.637,0,0,1,0-.748,0.354,0.354,0,0,1,.585,0L8.95,12.926l4.278-6.8a0.412,0.412,0,0,1,.618,0A0.506,0.506,0,0,1,13.846,6.8Z"
      }))), _react.default.createElement("p", {
        className: _AlertModule.default.text
      }, message)), _react.default.createElement("i", {
        className: "icon-close",
        onClick: onClose
      })), status === "warning" && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: _AlertModule.default.content
      }, _react.default.createElement("div", {
        className: _AlertModule.default.icon
      }, _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, _react.default.createElement("g", {
        id: "Artboard_1_copy",
        "data-name": "Artboard 1 copy"
      }, _react.default.createElement("path", {
        id: "Rounded_Rectangle_763",
        "data-name": "Rounded Rectangle 763",
        className: "cls-1",
        d: "M40,20c-5.523,0-10-3.976-10-9.677A10.165,10.165,0,0,1,40,0,10,10,0,1,1,40,20ZM39.985,1a9.157,9.157,0,0,0-9,9.31c0,5.131,4.017,8.69,9,8.69A9,9,0,1,0,39.985,1ZM40,15a1,1,0,1,1,1-1A1,1,0,0,1,40,15Zm0-4a1,1,0,0,1-1-1V6a1,1,0,1,1,2,0v4A1,1,0,0,1,40,11Z",
        transform: "translate(-30)"
      })))), _react.default.createElement("p", {
        className: _AlertModule.default.text
      }, message)), _react.default.createElement("i", {
        className: "icon-close",
        onClick: onClose
      })), status === "error" && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: _AlertModule.default.content
      }, _react.default.createElement("div", {
        className: _AlertModule.default.icon
      }, _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, _react.default.createElement("g", {
        id: "Artboard_1_copy",
        "data-name": "Artboard 1 copy"
      }, _react.default.createElement("path", {
        id: "Rounded_Rectangle_763",
        "data-name": "Rounded Rectangle 763",
        className: "cls-1",
        d: "M40,20c-5.523,0-10-3.976-10-9.677A10.165,10.165,0,0,1,40,0,10,10,0,1,1,40,20ZM39.985,1a9.157,9.157,0,0,0-9,9.31c0,5.131,4.017,8.69,9,8.69A9,9,0,1,0,39.985,1ZM40,15a1,1,0,1,1,1-1A1,1,0,0,1,40,15Zm0-4a1,1,0,0,1-1-1V6a1,1,0,1,1,2,0v4A1,1,0,0,1,40,11Z",
        transform: "translate(-30)"
      })))), _react.default.createElement("p", {
        className: _AlertModule.default.text
      }, message)), _react.default.createElement("i", {
        className: "icon-close",
        onClick: onClose
      })));
    }
  }]);

  return Alert;
}(_react.default.Component);

Alert.propTypes = {
  onClose: _propTypes.default.func,
  hide: _propTypes.default.bool,
  status: _propTypes.default.string,
  message: _propTypes.default.string
};
var _default = Alert;
exports.default = _default;